export default __webpack_public_path__ + "static/media/RockinAroundTheChristmasTree.cb15a868.mp3";